module.exports = __webpack_public_path__ + "img/VV.dd8ee58c.png";